export default "__VITE_ASSET__DCIAuQd3__"